module.exports = __webpack_public_path__ + "img/stock2.63a6fe71.png";